import { defineStore } from 'pinia'

import { StoreId } from '@/store'
import { DEFAULT_STATE } from '@/store/addressSystem/address-system.constants'
import type { AddressSystemStates } from '@/store/addressSystem/address-system.types'

import type {
  AddressSystemDialogState,
  AddressSystemMenuState,
  DialogContentState,
} from '@/types/address-system'

export const useAddressSystemStateStore = defineStore(
  StoreId.ADDRESS_SYSTEM_STATE,
  {
    state: (): AddressSystemStates => DEFAULT_STATE,
    actions: {
      changeDialogState(state: AddressSystemDialogState) {
        this.$state.dialogState = state
      },
      changeDialogContent(state: DialogContentState) {
        this.$state.prevDialogContent = this.$state.dialogContent
        this.$state.dialogContent = state
      },
      changeMenuState(state: AddressSystemMenuState) {
        this.$state.menuState = state
      },
    },
  },
)
